<div class="container" xmlns="http://www.w3.org/1999/html">
  <div class="card">
    <div class="d-flex flex-row justify-content-between form-group mt-2 mb-5">
      <div [hidden]="!getAccountStatusUtil().isPaymentOutstanding(account?.accountState) || !hasRouteAccess(routes.SECURE.ACCOUNT.EDIT)">
        <button (click)="edit()" class="btn btn-standard action-btn" type="button">
          <i class="fa fa-edit"></i> Edit
        </button>
      </div>
      <span></span>
      <div>
        <button (click)="back()" class="btn btn-standard action-btn" type="button">
          <i class="fa fa-arrow-left"></i> Back
        </button>
      </div>
    </div>
    <div class="card-body text-center">
      <p><strong>Biller Reference:</strong> {{ account?.referenceNumber }}</p>
      <p><strong>Recipient:</strong> {{ account?.customer }}</p>
      @if (account?.customerVatNumber) {
        <p><strong>VAT Number:</strong> {{ account?.customerVatNumber }}</p>
      }
      <p><strong>Amount:</strong> {{ account?.amount | currency:'R' }}</p>

            @if (account?.multiPremium) {
                <p><strong>Multi Premium Option:</strong> {{ account?.multiPremium }}</p>
            }

      @if (account?.description == null || account?.description.length == 0) {
        <p>{{ account?.description }}</p>
      }

      @if (account) {
        <div class="row">
          <div class="form-group col-md-12">
            <h6>Scan to Pay</h6>
            <qrcode [elementType]="'svg'"
              [errorCorrectionLevel]="'M'"
              [qrdata]="account?.qrCode"
            [width]="256"></qrcode>
            <h6>Pay&#64; ({{ instanceName }}) #: {{ getPayAtNumber(account?.qrCode) }}</h6>
          </div>
        </div>
      }
      <form [formGroup]="form">
        <div [class]="isQuickPay ? 'row center-quick-pay-sms' : 'row'">
          @if (!isQuickPay) {
            <div class="col-lg-5 col-sm-12">
              <div class="card">
                <div class="card-header title"><h2 class="mb-0">Email</h2> &nbsp;
                <p class="message-credit-font mb-0">({{ messageCounters?.emailCounter }}
                remaining)</p></div>
                <div class="card-body">
                  <div class="form-group">
                    <label class="float-left" for="emailInput">Email Address:</label> <input
                    [ngClass]="{ 'is-invalid': displayError(f.customerEmail)}"
                    class="form-control"
                    formControlName="customerEmail"
                    id="emailInput"
                    placeholder="Email"
                    type="text"/>
                  @if (displayError(f.customerEmail)) {
                    <div class="invalid-feedback">
                      @if (f.customerEmail.errors.required) {
                        <div>Email is required
                        </div>
                      }
                      @if (f.customerEmail.errors.email) {
                        <div>Invalid email
                        </div>
                      }
                    </div>
                  }
                </div>
                <div class="form-group margin-top-10">
                  <label class="float-left" for="invoice">Auto-Generate Invoice:
                    <span>
                                                <i class="pi pi-question-circle tooltip-icon" pTooltip="Will generate and attach an invoice
                                                with the request to pay transaction email. This setting overrides the
                                                default value set in the Account Settings page.">
                      </i>
                    </span>
                  </label>
                  <p-toggleswitch formControlName="sendInvoice" id="invoice"></p-toggleswitch>
                </div>
                <div class="button-container">
                  <button (click)="onSubmit('email')"
                    [disabled]="loadingSMS || loadingEmail"
                    class="orange-btn edit-btn"
                    id="send-email"
                    type="button">
                    Send Email&nbsp; <i class="fa-regular fa-envelope fa-lg"></i>
                    <i [hidden]="!loadingEmail"
                      class="fa fa-spinner fa-spin"
                    style="font-size:15px"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-1 col-sm-12">
            <h2>OR</h2>
          </div>
        }
        <div class="col-lg-5 col-sm-12">
          <div class="card">
            <div class="card-header title"><h2 class="mb-0">Mobile Notification</h2> &nbsp;
            <p class="message-credit-font mb-0">({{ messageCounters?.smsCounter }} SMSs
            remaining)</p></div>
            <div class="card-body">
              <div class="form-group">
                <validation [formGroup]="form" controlName="customerMobileNumber" displayName="Mobile number">
                  <label class="float-left" for="mobileInput">Mobile Number:</label>
                  <input [ngClass]="{ 'is-invalid': displayError(f.customerMobileNumber) }"
                    class="form-control"
                    formControlName="customerMobileNumber"
                    id="mobileInput"
                    placeholder="0831234567 or +27831234567"
                    type="tel"/>
                </validation>
              </div>
              <div class="padding-space"></div>
              <div class="button-container">
                <button (click)="onSubmit('sms')"
                  [disabled]="loadingSMS || loadingEmail"
                  class="orange-btn edit-btn"
                  id="send-sms"
                  type="button">
                  Send SMS&nbsp; <i class="fa-regular fa-message fa-lg"></i>
                  <i [hidden]="!loadingSMS"
                    class="fa fa-spinner fa-spin"
                  style="font-size:15px"></i>
                </button>
                <button (click)="onSubmit('whatsappRtp')"
                  [disabled]="loadingSMS || loadingEmail"
                  class="orange-btn edit-btn"
                  type="button">
                  Send WhatsApp&nbsp; <i class="fa-brands fa-whatsapp fa-lg"></i>
                  <i [hidden]="!loadingSMS"
                    class="fa fa-spinner fa-spin"
                  style="font-size:15px"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<pre [hidden]="!isDeveloperMode()"><code>{{ getAllErrors(form) | json }}</code></pre>
</div>
<ngx-ui-loader></ngx-ui-loader>